import i18n from '../i18n';
import type { PresenceDto } from '../api/types';

/** Период поллинга presence собеседника в личном чате — используется и в шапке чата
 *  (ChatView), и в инфопанели (ChatInfoModal), пока соответствующая панель открыта. */
export const PRESENCE_POLL_MS = 20_000;

/** «в сети» / «был(а) N минут/часов/недель/месяцев/лет назад» / «был(а) DD.MM.YYYY» (после года). */
export function formatPresence(p: PresenceDto): string {
  if (p.online) return i18n.t('misc2:presenceOnline');
  if (!p.lastOnlineAt) return i18n.t('misc2:presenceOffline');
  const diffMs = Date.now() - new Date(p.lastOnlineAt).getTime();
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 1) return i18n.t('misc2:presenceJustNow');
  if (minutes < 60) return i18n.t('misc2:presenceAgoMinutes', { count: minutes });
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return i18n.t('misc2:presenceAgoHours', { count: hours });
  const days = Math.floor(hours / 24);
  if (days === 1) return i18n.t('misc2:presenceYesterday');
  if (days < 7) return i18n.t('misc2:presenceAgoDays', { count: days });
  const weeks = Math.floor(days / 7);
  if (weeks < 5) return i18n.t('misc2:presenceAgoWeeks', { count: weeks });
  const months = Math.floor(days / 30);
  if (months < 12) return i18n.t('misc2:presenceAgoMonths', { count: months });
  const years = Math.floor(days / 365);
  if (years < 2) return i18n.t('misc2:presenceOverYearAgo');
  return i18n.t('misc2:presenceAgoYears', { count: years });
}
